import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { Anchor, Box, Group, ScrollArea, Text, Button } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconFile } from "@tabler/icons-react";
import dayjs from "dayjs";
import DOMPurify from "dompurify";

import { TimezoneContext } from "../../App.tsx";
import { Mail } from "../../models/Mail.ts";
import classes from "../../styles/components/modals/MailDetails.module.scss";

export const MailDetails = (selectedMail: Mail) => {
  const browserTimezone = useContext(TimezoneContext);
  const navigate = useNavigate();

  const openTemplateEdition = (templateCode: string) => {
    navigate(`/templates/${templateCode}`);
    modals.closeAll();
  };

  const icon = <IconFile />;

  return (
    <>
      <Text className={classes.textLabel}>From</Text>
      <Text className={`${classes.textBorder} ${classes.textContent}`}>
        {selectedMail.senderEmail}
      </Text>
      <Text className={classes.textLabel}>To</Text>
      <Text className={`${classes.textBorder} ${classes.textContent}`}>
        {selectedMail.receiverEmail}
      </Text>
      {selectedMail.ccs != null && selectedMail.ccs.length > 0 ? (
        <>
          <Text className={classes.textLabel}>CCs</Text>
          <Text className={`${classes.textBorder} ${classes.textContent}`}>
            {selectedMail.ccs?.map((email) => email).join("; ")}
          </Text>
        </>
      ) : (
        <></>
      )}
      {selectedMail.bccs != null && selectedMail.bccs.length > 0 ? (
        <>
          <Text className={classes.textLabel}>BCCs</Text>
          <Text className={`${classes.textBorder} ${classes.textContent}`}>
            {selectedMail.bccs?.map((email) => email).join("; ")}
          </Text>
        </>
      ) : (
        <></>
      )}
      <ScrollArea className={`${classes.textBorder} ${classes.textContent}`} h={"60%"}>
        <Box
          size={"xl"}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(selectedMail.body) }}
        />
      </ScrollArea>

      <Group>
        {selectedMail.attachmentUrls.map((attachment, i) => {
          const url = new URL(attachment);
          const fileName = url.pathname.split("/").pop();
          return (
            <a href={attachment} key={i}>
              <Button leftSection={icon} color={"blue"} variant={"outline"}>
                {fileName}
              </Button>
            </a>
          );
        })}
      </Group>

      <Text size={"xs"}>
        {"Template used : "}
        {selectedMail.templateCode === null ? (
          "None"
        ) : (
          <Anchor onClick={() => openTemplateEdition(selectedMail.templateCode)}>
            {selectedMail.templateCode}
          </Anchor>
        )}
      </Text>

      <Text size={"xs"}>
        {"Created "}
        {dayjs(selectedMail.createdAt).tz(browserTimezone).format("dddd, MMMM D, YYYY h:mm A") ??
          "Unknown"}
      </Text>
      {selectedMail.lastRetry && (
        <Text size={"xs"}>
          {"Last retry : "}
          {dayjs(selectedMail.lastRetry).tz(browserTimezone).format("dddd, MMMM D, YYYY h:mm A") ??
            "Unknown"}
        </Text>
      )}
    </>
  );
};
